import { useMemo } from 'react';
import { IService } from '../models/IService';
import { IEmployeeAvailability } from '../models/IEmployeeAvailability';

interface IBookingConfirmationValidationProps {
  selectedService?: IService | null;
  selectedEmployee?: IEmployeeAvailability | null;
  selectedDate?: Date | null;
  selectedTime?: string | null;
  termsAccepted?: boolean;
  isAuthenticated?: boolean;
}

export const useBookingConfirmationValidation = ({
  selectedService,
  selectedEmployee,
  selectedDate,
  selectedTime,
  termsAccepted = false,
  isAuthenticated = false,
}: IBookingConfirmationValidationProps) => {
  
  const validationErrors = useMemo(() => {
    const errors: string[] = [];
    
    if (!selectedService) {
      errors.push('Моля, изберете услуга');
    }
    
    if (!selectedEmployee) {
      errors.push('Моля, изберете специалист');
    }
    
    if (!selectedDate) {
      errors.push('Моля, изберете дата');
    }
    
    if (!selectedTime) {
      errors.push('Моля, изберете час');
    }
    
    if (!termsAccepted) {
      errors.push('Моля, приемете общите условия');
    }
    
    if (!isAuthenticated) {
      errors.push('Моля, влезте в профила си за да завършите резервацията');
    }
    
    return errors;
  }, [selectedService, selectedEmployee, selectedDate, selectedTime, termsAccepted, isAuthenticated]);
  
  const isValid = useMemo(() => {
    return validationErrors.length === 0;
  }, [validationErrors]);
  
  const canProceed = useMemo(() => {
    // For now, we can proceed even without authentication (will redirect later)
    const requiredFieldsPresent = !!(
      selectedService && 
      selectedEmployee && 
      selectedDate && 
      selectedTime
    );
    
    return requiredFieldsPresent && termsAccepted;
  }, [selectedService, selectedEmployee, selectedDate, selectedTime, termsAccepted]);
  
  const getValidationMessage = (): string => {
    if (validationErrors.length === 0) {
      return '';
    }
    
    if (validationErrors.length === 1) {
      return validationErrors[0];
    }
    
    return `${validationErrors.length} проблема: ${validationErrors.slice(0, 2).join(', ')}${
      validationErrors.length > 2 ? '...' : ''
    }`;
  };
  
  return {
    isValid,
    canProceed,
    validationErrors,
    validationMessage: getValidationMessage(),
  };
};